<template v-if="itemVariation || item">
  <action-dialog
    ref="toggleSalesDisabledDialog"
    :class="$q.screen.gt.xs ? 'q-px-xl' : 'q-px-md'"
    :title="title"
    :ok-label="$t('actions.confirm')"
    :ok-disable="okDisable"
    :cancel-label="$t('actions.cancel')"
    ok-color="positive"
    cancel-color="negative"
    persistent
    buttons-inlined
    reverse-buttons-row
    data-test-id="toggle-sales-disabled-dialog"
    @ok="currentUser.admin
      ? toggleSalesDisabled()
      : $emit('request-authorization', () => toggleSalesDisabled())
    "
  />
</template>

<script>
import Item from 'src/models/item/Item'
import ItemVariation from 'src/models/item/ItemVariation'
import ActionDialog from 'src/modules/consumer/components/ActionDialog'

export default {
  name: 'ToggleSalesDisabledDialog',
  components: {
    ActionDialog
  },
  context: ['currentUser'],
  configuration: ['currentSite'],
  props: {
    item: {
      type: Item,
      required: true,
      default: null
    },
    itemVariation: {
      type: ItemVariation,
      required: false,
      default: null
    }
  },
  emits: ['request-authorization'],
  computed: {
    title () {
      if (this.itemVariation) {
        return `${this.itemVariation.salesDisabled ? 'Enable Sales' : 'Disable Sales'} for ${this.itemVariation.nameWithItem}`
      } else {
        return `${this.item.areSalesRequirementsUnmet ? 'Enable Sales' : 'Disable Sales'} for ${this.item.displayName}`
      }
    },
    okDisable () {
      if (this.itemVariation) return false

      return this.item.areSalesRequirementsUnmet && !this.item.salesDisabled
    }
  },
  methods: {
    show () {
      this.$refs.toggleSalesDisabledDialog.show()
    },
    hide () {
      this.$refs.toggleSalesDisabledDialog.hide()
    },
    async toggleSalesDisabled () {
      const itemVariationOrItem = this.itemVariation || this.item

      if (itemVariationOrItem.salesDisabled) {
        await itemVariationOrItem.enableSales()
      } else {
        await itemVariationOrItem.disableSales()
      }
    }
  }
}
</script>
